module.exports = __webpack_public_path__ + "media/college_jobs_internships/jobs_primary-29e77736.png";